import { Stack } from "@mui/material";
import { omit } from "lodash-es";
import type { FC } from "react";
import { prettyChannelName } from "../../../../channels/utils";
import { PreviewMissingButton } from "./components/preview-missing-button";
import { PreviewPersonsButton } from "./components/preview-persons-button";
import { PreviewTooltip } from "./components/preview-tooltip";
import { usePersonsAndMissing } from "./hooks/use-persons-and-missing";
import { PreviewDatagrid } from "./preview-datagrid";
import type { PreviewProps } from "./types";
import { subjectToChange } from "./utils";

export const ManagerPreview: FC<PreviewProps<"manager">> = ({ data, channel, ...rest }) => {
  const { persons, missing } = usePersonsAndMissing(channel, data);
  const channelName = prettyChannelName(channel);
  const recipientLabel = persons.length === 1 ? "recipient" : "recipients";
  const managerLabel = data.length === 1 ? "Manager" : "Managers";
  const previewTitle =
    `${persons.length} ${channelName} ${recipientLabel} for ` +
    `${data.length} ${managerLabel} of people in the segment. ` +
    subjectToChange;
  const missingManagerLabel = missing.length === 1 ? "Manager" : "Managers";
  const missingVerb = missing.length === 1 ? "doesn't" : "don't";
  const missingButtonText = `${missing.length} ${missingManagerLabel} of people in segment ${missingVerb} have a ${channelName} connected.`;

  return (
    <>
      <Stack direction="column" alignItems="flex-end" {...omit(rest, "preview_config")}>
        <Stack direction="row" spacing={2} alignItems="center">
          <PreviewPersonsButton
            persons={persons.length}
            channel={channel}
            buttonText="Manager Recipients: "
          >
            <PreviewDatagrid channelName={channel} persons={persons} connection="Manager" />
          </PreviewPersonsButton>

          <PreviewTooltip title={previewTitle} />
        </Stack>
        {missing.length > 0 && (
          <PreviewMissingButton buttonText={missingButtonText} channelName={channel}>
            <PreviewDatagrid channelName={null} persons={missing} connection="Manager" />
          </PreviewMissingButton>
        )}
      </Stack>
    </>
  );
};
